import { render, staticRenderFns } from "./BSShowReviewModal.vue?vue&type=template&id=f4e4bd4a"
import script from "./BSShowReviewModal.vue?vue&type=script&lang=js"
export * from "./BSShowReviewModal.vue?vue&type=script&lang=js"
import style0 from "./BSShowReviewModal.vue?vue&type=style&index=0&id=f4e4bd4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports